import OurProcess from "./our-process";
import Reviews from "./reviews";
import FAQ from "./faq";
import Banner from "./banner";
import ContactSection from "./cta";
import Parallax from "./parallax";
import FrameButton from "./frame-button";
import AboutSignService from "./AboutSignService";
import NewService from "./NewService";
import { SignageStrategySection } from "./StrategySection";
import TechnicalExcellence from "./TechnicalExcellence";
import LocationCTASection from "./LocationCTASection";
import VerticalSlider from "../../components/core/vertical-slider";
import GetStartedSection from "./GetStartedSection";
import { useEffect } from "react";
const imageUrls: string[] = [
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/ppc.jpg?v=1768289108&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/scott-graham-5fNmWej4tAA-unsplash.jpg?v=1768288538&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/smart-phone.jpg?v=1768289006&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/google-paid-ad.jpg?v=1768288956&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/planning.jpg?v=1768288795&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/ppc.jpg?v=1768289108&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/scott-graham-5fNmWej4tAA-unsplash.jpg?v=1768288538&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/smart-phone.jpg?v=1768289006&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/google-paid-ad.jpg?v=1768288956&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/planning.jpg?v=1768288795&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/ppc.jpg?v=1768289108&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/scott-graham-5fNmWej4tAA-unsplash.jpg?v=1768288538&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/smart-phone.jpg?v=1768289006&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/google-paid-ad.jpg?v=1768288956&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/planning.jpg?v=1768288795&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/ppc.jpg?v=1768289108&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/scott-graham-5fNmWej4tAA-unsplash.jpg?v=1768288538&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/smart-phone.jpg?v=1768289006&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/google-paid-ad.jpg?v=1768288956&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/planning.jpg?v=1768288795&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/ppc.jpg?v=1768289108&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/scott-graham-5fNmWej4tAA-unsplash.jpg?v=1768288538&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/smart-phone.jpg?v=1768289006&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/google-paid-ad.jpg?v=1768288956&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/planning.jpg?v=1768288795&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/ppc.jpg?v=1768289108&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/scott-graham-5fNmWej4tAA-unsplash.jpg?v=1768288538&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/smart-phone.jpg?v=1768289006&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/google-paid-ad.jpg?v=1768288956&quality=50&width=1700&height=1200",
  "https://cdn.shopify.com/s/files/1/0994/4979/8950/files/planning.jpg?v=1768288795&quality=50&width=1700&height=1200",
];
const MetalFXPage = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      throw new Error("Sentry Delayed Production Error Test");
    }, 10000);

    return () => clearTimeout(timer);
  }, []);
  const size = Math.ceil(imageUrls.length / 3);
  const renderImages = (images: string[]) => {
    return images?.map((image, i) => (
      <div
        key={`image-item-${i}`}
        className="min-w-full h-[450px] md:h-[500px] overflow-hidden rounded-2xl"
      >
        <img
          className="w-full h-full object-top object-cover"
          alt={image}
          src={image}
        />
      </div>
    ));
  };
  return (
    <div className="flex flex-col w-full h-auto font-inter bg-[#111212]">
      <Banner />
      <OurProcess />
      <div className="w-full h-auto relative z-10">
        <Parallax
          intro={
            <div className="flex flex-col w-full h-screen relative bg-[#111212]">
              <AboutSignService />
            </div>
          }
          outro={
            <div className="flex flex-col h-auto min-h-fit bg-[#111212] ">
              <div className="w-full flex h-auto px-2.5 md:px-6">
                <GetStartedSection />
              </div>
            </div>
          }
          frame={<FrameButton />}
        >
          <div className="w-full h-full flex items-center justify-center bg-[#111212] relative">
            <div className="w-full px-10 gap-5 md:gap-3 h-full grid grid-cols-2 md:grid-cols-3 justify-center items-center">
              <VerticalSlider duration={40} direction={1}>
                {renderImages(imageUrls?.slice(0, size))}
              </VerticalSlider>
              <VerticalSlider duration={45} direction={-1}>
                {renderImages(imageUrls?.slice(size, size * 2))}
              </VerticalSlider>
              <div className="md:flex hidden">
                <VerticalSlider duration={42} direction={1}>
                  {renderImages(imageUrls?.slice(size * 2))}
                </VerticalSlider>
              </div>
            </div>
          </div>
        </Parallax>
        <NewService />
        <SignageStrategySection />
        <TechnicalExcellence />
      </div>
      <Reviews />
      <FAQ />
      <LocationCTASection />
      <ContactSection />
    </div>
  );
};

export default MetalFXPage;
